import { BaseBody } from '../BaseBody.js';
import { CssVars } from '../../../util/CssVars.js';

const glyphname = 'oligonYpsiliRightKentimata';
const args = {};

export class OligonYpsiliRightKentimata extends BaseBody {
  constructor() {
    super(glyphname, args);
  }
}
